module.exports = __webpack_public_path__ + "static/media/BBI LOGO_800X533-01.5203c612.png";